var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('yandex-map',{attrs:{"settings":_vm.settings,"coords":_vm.coords,"zoom":_vm.zoom,"controls":_vm.controls},on:{"map-was-initialized":_vm.mapInit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }